import { Pipe, PipeTransform } from '@angular/core';
import { EnumConverter } from '../classes';
import { AGENT_RELATIONSHIP } from '../enums';

@Pipe({
  name: 'agentRelationship'
})
export class AgentRelationshipPipe extends EnumConverter implements PipeTransform {
  enumeration = AGENT_RELATIONSHIP;
}
